/*!
 * Copyright © 2018-2020. Verizon Connect Ireland Limited. All rights reserved.
 */

import { INotification, INotificationDetails } from '../../models';

export interface INotificationsState {
  notifications: INotification[];
  notificationDetail: INotificationDetails;
  shouldShowNonPanicNotifications: boolean;
}

export const initialNotificationsState: INotificationsState = {
  notifications: [],
  notificationDetail: null,
  shouldShowNonPanicNotifications: true
};
